<div class="relative">
  <ng-content></ng-content>
  @if (isLoading) {
    <div
      [ngClass]="fullscreen ? 'fixed' : 'absolute'"
      class="inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50"
      [style.z-index]="fullscreen ? 10000 : 1000"
      >
      <bv-logo-loader [size]="logoPx"></bv-logo-loader>
    </div>
  }
</div>
